"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerStyledDisplayGrid = exports.defaultDataGridProps = exports.SelectionMode = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_queries_1 = require("@tableau/catalog-queries");
const DataGridStyles_1 = require("../style/DataGridStyles");
const VizPortalStyles_1 = require("../style/VizPortalStyles");
const DataGridWithSynchronousRowStore_1 = require("./DataGridWithSynchronousRowStore");
const EmptyGridElement_1 = require("./EmptyGridElement");
const SelectionColumn_1 = require("./SelectionColumn");
exports.SelectionMode = {
    /** A row will be selected only when the user interacts with the Selection Cell */
    Cell: 'cell',
    /** A row will be selected when the user interacts with any cell of the row */
    Row: 'row',
};
exports.defaultDataGridProps = {
    // This is to make the total left margin match the ExtraLargeSpace (24) margin in the header.
    // Our cell formatters add MediumSpace (12), so this adds another MediumSpace (12).
    leftMargin: widgets_1.TabStyles.Spacing.MediumSpace,
    showHeaders: true,
    showRowBanding: false,
    showHorizontalGridLines: true,
};
/**
 * A DataGrid with styling to match VizPortal Client's "Explorer" grid used for main lists.
 */
class ExplorerStyledDisplayGrid extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.handleGridErrors = (_, gridErrors) => {
            this.setState({ gridErrors });
        };
        this.onDoubleClickEvent = (rowData, cell) => {
            if (this.props.doubleClickForKey && cell.rowKey) {
                this.props.doubleClickForKey(cell.rowKey);
            }
        };
        this.onSelectionEvent = (event) => {
            if (this.props.updateSelectionForKey && event.cell.rowKey && this.isSelectionEvent(event)) {
                this.props.updateSelectionForKey(event.cell.rowKey);
                if (this.props.updateSelectedRowId) {
                    this.props.updateSelectedRowId(event.cell.rowIdx);
                }
                return true;
            }
            // We update selection state in an ancestor component, so we don't need to tell the grid to update too
            return false;
        };
        this.isSelectionEvent = (event) => {
            return this.props.selectionMode && this.props.selectionMode === exports.SelectionMode.Row
                ? (0, SelectionColumn_1.isSelectionRowEvent)(event)
                : (0, SelectionColumn_1.isSelectionColumnEvent)(event);
        };
        this.rowSelectionModel = {
            isSelected: (cell) => {
                const selectedKeys = this.props.selectedKeys;
                return (cell.rowKey && selectedKeys) ? !!selectedKeys[cell.rowKey] : false;
            },
        };
        this.state = {
            gridErrors: [],
        };
    }
    render() {
        const dataGridProps = Object.assign(Object.assign({}, exports.defaultDataGridProps), { cols: this.props.columns, rowStore: this.props.rowStore, selectionModel: this.rowSelectionModel, onSelectionEvent: this.onSelectionEvent, onCellDoubleClick: this.onDoubleClickEvent, 
            // The following config was lifted from the VPC/Spaces ListView.tsx
            config: {
                colsPerChunk: this.props.columns.length,
                rowOuterHeight: VizPortalStyles_1.ListViewRowOuterHeight,
            }, showSpinnerWhileLoading: true, onError: this.handleGridErrors, sortKey: this.props.orderBy && this.props.orderBy.field, sortAscending: this.props.orderBy ? (this.props.orderBy.direction === catalog_queries_1.OrderDirection.ASC) : undefined });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DataGridStyles_1.ExplorerStyledDataGridContainer, null, this.props.rowCount === 0
                ? react_1.default.createElement(EmptyGridElement_1.EmptyGridElement, { emptyGridMessage: this.props.emptyGridMessage })
                : react_1.default.createElement(DataGridWithSynchronousRowStore_1.DataGridWithSynchronousRowStore, Object.assign({}, dataGridProps))),
            this.state.gridErrors.length > 0 ? this.props.renderErrors(this.state.gridErrors) : null));
    }
}
exports.ExplorerStyledDisplayGrid = ExplorerStyledDisplayGrid;
//# sourceMappingURL=ExplorerStyledDisplayGrid.js.map